import React, { useState } from 'react';
import { Toast } from '../../components/molecules/Toast/Toast';
import PortfolioApprovalsOrganism from '../../components/organisms/PortfolioApprovals';
import { usePortfolioApprovals, Approval } from './hooks';
import PortfolioApprovalSummary from './approval-summary';
import PortfolioApprovalDetails from './approval-details';

const PortfolioApprovals: React.FC = () => {
    const { pendingApprovals, approve, reject, isLoading, actionLoading, snackbar, handleDownload } =
        usePortfolioApprovals();
    const [open, setOpen] = useState(true);

    const summaryComponent = (item: Approval) => (
        <PortfolioApprovalSummary
            id={item.id}
            date={item.date}
            tenant={item.tenant}
            property={item.property}
            fundTypes={item.fundTypes || ''}
            portfolioType={item.portfolioType || ''}
            fileName={item.fileName || ''}
            fileId={item.fileId || ''}
            submitter={item.submitter}
            userId={item.userId}
            onApprove={() => approve(item.id, item.tenant)}
            onReject={() => reject(item.id, item.tenant)}
        />
    );

    const detailsComponent = (item: Approval) => (
        <PortfolioApprovalDetails
            id={item.id}
            date={item.date}
            tenant={item.tenant}
            property={item.property}
            fundTypes={item.fundTypes || ''}
            portfolioType={item.portfolioType || ''}
            fileName={item.fileName || ''}
            fileId={item.fileId || ''}
            submitter={item.submitter}
            userId={item.userId}
            goalCategory={item.goalCategory}
            portfolioBundleName={item.portfolioBundleName}
            onApprove={() => approve(item.id, item.tenant)}
            onReject={() => reject(item.id, item.tenant)}
            onDownload={() => handleDownload(item.fileId || '', item.fileName || 'file.xlsx')}
        />
    );

    return (
        <>
            <PortfolioApprovalsOrganism
                pendingApprovals={pendingApprovals}
                open={open}
                onApprove={approve}
                onReject={reject}
                onToggle={() => setOpen((prev) => !prev)}
                isLoading={isLoading}
                actionLoading={actionLoading}
                hasExpandableDetails={true}
                summaryComponent={summaryComponent}
                detailsComponent={detailsComponent}
            />
            {snackbar.open && (
                <Toast
                    heading={snackbar.type === 'success' ? 'Approved' : 'Rejected'}
                    type={snackbar.type === 'success' ? 'confirm' : 'error'}
                    disappearTime={5}
                    isTimer={true}
                    messages={[snackbar.message]}
                />
            )}
        </>
    );
};

export default PortfolioApprovals;
